import { Inject, Injectable } from '@angular/core';
import { MSAL_GUARD_CONFIG } from '@azure/msal-angular';
import { msalConfig } from '../model';
import { Logout, LogoutFailed, RequestLogout, UpdateUser, UserState } from '../../../shared/state';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import * as i0 from "@angular/core";
import * as i1 from "@azure/msal-angular";
import * as i2 from "@ngxs/store";
export class LoginService {
  authService;
  ngxsStore;
  destroyed;
  msalGuardConfig;
  noAuth = false;
  currentAuthState = "not set" /* AuthState.NotSet */;
  constructor(authService, ngxsStore, destroyed, msalGuardConfig) {
    this.authService = authService;
    this.ngxsStore = ngxsStore;
    this.destroyed = destroyed;
    this.msalGuardConfig = msalGuardConfig;
    this.ngxsStore.select(UserState.authState).pipe(takeUntilDestroyed(this.destroyed)).subscribe(authState => {
      this.currentAuthState = authState;
    });
  }
  login(userFlowRequest) {
    if (this.msalGuardConfig.authRequest) {
      this.authService.loginRedirect({
        ...this.msalGuardConfig.authRequest,
        ...userFlowRequest
      });
    } else {
      this.authService.loginRedirect(userFlowRequest);
    }
  }
  setClaimValues(claims) {
    if (claims) {
      let username = '';
      let memberships = [];
      if (claims.given_name && claims.family_name) {
        username = claims.given_name + ' ' + claims.family_name;
      } else if (claims.name) {
        username = claims.name;
      }
      if (claims.extension_memberships) {
        const parsedMemberships = JSON.parse(claims['extension_memberships']);
        memberships = Object.entries(parsedMemberships).map(([id, details]) => ({
          id,
          name: details.name,
          roles: details.roles
        }));
      }
      const currentUser = this.ngxsStore.selectSnapshot(UserState.user);
      const isMembershipEqual = JSON.stringify(memberships.map(m => m.id).sort((a, b) => a.localeCompare(b))) === JSON.stringify(currentUser.memberships?.map(m => m.id).sort((a, b) => a.localeCompare(b)));
      if (claims.oid && claims.oid !== currentUser.userId || username !== currentUser.userName || !isMembershipEqual) {
        const userId = claims.oid ?? '';
        this.ngxsStore.dispatch(new UpdateUser(userId, username, memberships));
      }
    }
  }
  logout() {
    this.logoutAndRedirect();
  }
  logoutAndRedirect(redirectUri) {
    const currentAccount = this.authService.instance.getActiveAccount();
    const logoutUri = redirectUri || msalConfig.auth.postLogoutRedirectUri;
    this.ngxsStore.dispatch(new RequestLogout());
    this.ngxsStore.select(UserState.token).pipe(takeUntilDestroyed(this.destroyed)).subscribe(token => {
      if (token && currentAccount && logoutUri) {
        const logoutRequest = {
          account: currentAccount,
          postLogoutRedirectUri: logoutUri,
          idTokenHint: token
        };
        this.authService.logoutRedirect(logoutRequest).pipe(takeUntilDestroyed(this.destroyed)).subscribe({
          next: () => {
            return this.ngxsStore.dispatch(new Logout());
          },
          error: () => this.ngxsStore.dispatch(new LogoutFailed())
        });
      }
    });
  }
  static ɵfac = function LoginService_Factory(t) {
    return new (t || LoginService)(i0.ɵɵinject(i1.MsalService), i0.ɵɵinject(i2.Store), i0.ɵɵinject(i0.DestroyRef), i0.ɵɵinject(MSAL_GUARD_CONFIG));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: LoginService,
    factory: LoginService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoginService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.MsalService
  }, {
    type: i2.Store
  }, {
    type: i0.DestroyRef
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [MSAL_GUARD_CONFIG]
    }]
  }], null);
})();
